import {
    CheckCircleOutlined,
    CloseCircleOutlined,
    ReloadOutlined,
    UnorderedListOutlined,
} from "@ant-design/icons";
import {
    Button,
    Card,
    Table,
    Tag,
    message,
    Modal,
    Input,
    Space,
    Tooltip,
} from "antd";
import { useState, useContext, useEffect } from "react";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import dayjs from "dayjs";

const { TextArea } = Input;

export default function MyStatusRequests() {
    const { authData, backUrl } = useContext(AuthContext);
    const isMobile = window.innerWidth < 768;

    // State management
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);

    // Modal state for approval/rejection
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [actionType, setActionType] = useState(""); // "approve" or "reject"
    const [remarks, setRemarks] = useState("");
    const [submitting, setSubmitting] = useState(false);


    // Fetch pending status change requests
    const fetchPendingRequests = async () => {
        setLoading(true);
        try {
            const url = `${backUrl}/api/hr/attendance-changes/my-requests/`;

            const res = await axios.get(url, {
                headers: { Authorization: `Bearer ${authData?.access}` },
                params: {
                    page: currentPage,
                    page_size: pageSize,
                },
            });

            const responseData = res.data;

            setDataSource(responseData.data || []);
            setTotalRecords(responseData.count || 0);

        } catch (error) {
            console.error("Error fetching pending requests:", error);
            message.error("Failed to fetch pending status change requests");
            setDataSource([]);
            setTotalRecords(0);
        } finally {
            setLoading(false);
        }
    };

    // Initial load
    useEffect(() => {
        fetchPendingRequests();
    }, [currentPage, pageSize]);

    // Handle table pagination change
    const handleTableChange = (pagination) => {
        setCurrentPage(pagination.current);
        setPageSize(pagination.pageSize);
    };


    // Table columns definition
    const columns = [
        {
            title: 'Requested By',
            dataIndex: "requested_by_name",
            key: 'requested_by'
        },
        {
            title: "Employee Code",
            dataIndex: "emp_code",
            key: "emp_code",
            width: 180,
        },
        {
            title: "Employee Name",
            dataIndex: "employee_name",
            key: "employee_name",
            width: 180,
        },
        {
            title: "Department",
            dataIndex: "department_name",
            key: "department",
            width: 150,
        },
        {
            title: "Designation",
            dataIndex: "designation_name",
            key: "designation",
            width: 150,
        },
        {
            title: "Attendance Date",
            dataIndex: "date",
            key: "date",
            width: 130,
        },
        {
            title: "Current Status",
            dataIndex: "status",
            key: "current_status",
            width: 130,
        },
        {
            title: "Requested Status",
            dataIndex: "pending_status_change",
            key: "new_status",
        },
        {
            title: "Remarks",
            dataIndex: "status_change_remarks",
            key: "remarks",
            width: 200,
        },
    ];

    return (
        <section>
            <center>
                {isMobile ? (
                    <p style={{ fontSize: "15px", textTransform: "uppercase", color: "#0e497b" }}>
                        Status Change Requests
                    </p>
                ) : (
                    <h5>
                        Attendance Status Change Requests
                    </h5>
                )}
            </center>

            {/* Requests Table */}
            <div style={{ margin: "20px" }}>
                <Table
                    columns={columns}
                    dataSource={dataSource}
                    bordered
                    loading={loading}
                    pagination={{
                        current: currentPage,
                        pageSize: pageSize,
                        total: totalRecords,
                        showSizeChanger: true,
                        pageSizeOptions: ["10", "20", "50", "100"],
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} records`,
                    }}
                    scroll={{ x: "max-content" }}
                    rowKey={(record) => record.id}
                    onChange={handleTableChange}
                    components={{
                        header: {
                            cell: (props) => (
                                <th
                                    {...props}
                                    style={{
                                        backgroundColor: "#0e497b",
                                        color: "white",
                                    }}
                                >
                                    {props.children}
                                </th>
                            ),
                        },
                    }}
                />
            </div>


        </section>
    );
}